export enum ScheduledReactionTableColumns {
  DATE = 'Date',
  CAPACITY = 'Capacity',
}
